<div [ngClass]="overFlowXEnabled ? 'table-container-overflow-x' : 'table-container'" class="w-full">
    <table class="material-table">
        <thead>
            <tr>
                <!-- Columna de checkbox si la tabla es seleccionable -->
                <th *ngIf="selectable" class="checkbox-column"></th>

                <!-- Columnas dinámicas basadas en la configuración -->
                <th *ngFor="let column of getVisibleColumns()" class="typography-table-m">
                    {{ (column.header || '') | translate }}
                </th>
            </tr>
        </thead>
        <tbody>
            <!-- Mensaje cuando no hay datos -->
            <tr *ngIf="!data?.length" class="no-data">
                <td [attr.colspan]="selectable ? getVisibleColumns().length + 1 : getVisibleColumns().length">
                    {{ noDataMessage | translate }}
                </td>
            </tr>

            <!-- Filas de datos -->
            <tr *ngFor="let item of data; trackBy: trackByRow" [class.selected]="isSelected(item)" [ngClass]="{ 'bg-background-medium-00 text-text-state-disabled': isValueDisabled(item) }">
                <!-- Checkbox para selección si está habilitado -->
                <td *ngIf="selectable"
                    class="checkbox-column"
                    [matTooltip]="tooltipOnDisabled"
                    matTooltipPosition="above"
                    [matTooltipDisabled]="!hoverOnDisabled || !isValueDisabled(item)"
                >
                    <input type="checkbox" [disabled]="isValueDisabled(item)" [checked]="isSelected(item)" (change)="toggleSelection(item)">
                </td>

                <!-- Celdas dinámicas basadas en la configuración de columnas -->
                <td *ngFor="let column of getVisibleColumns(); let colIndex = index; trackBy: trackByCol" class="typography-body-m-regular whitespace-nowrap"
                    [ngClass]="{
                        'text-semantic-success': column.format === 'points' && getPropertyValue(item, column.key)?.toString().includes('+'),
                        'text-semantic-error': column.format === 'points' && getPropertyValue(item, column.key)?.toString().includes('-'),
                        'text-ellipsis overflow-hidden': column.format === 'translated_material',
                        'has-employee-phone-tooltip': shouldShowEmployeePhoneTooltip(colIndex, item)
                    }"
                    matTooltip="{{ formatValue(getPropertyValue(item, column.key), column.format, column.formatOptions, item) }}"
                    [matTooltipDisabled]="column.format === 'action'"
                    matTooltipTruncated
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="300"
                    matTooltipClass="custom-tooltip"
                    >
                    <div class="cell-content-with-tooltip" [class.has-employee-phone-tooltip]="shouldShowEmployeePhoneTooltip(colIndex, item)">
                    <div [class.cell-main-content]="shouldShowEmployeePhoneTooltip(colIndex, item)">
                    <ng-container [ngSwitch]="column.format">
                        <!-- Acción personalizada: botón para ver datos -->
                        <ng-container *ngSwitchCase="'action'">
                            <div class="action-buttons">
                                <button
                                    *ngFor="let rowAction of getVisibleActions(item)"
                                    type="button"
                                    class="contact-link"
                                    (click)="onActionClick(item, rowAction.action)">

                                    <span *ngIf="rowAction.iconSvg" [innerHTML]="rowAction.iconSvg"></span>
                                    <span *ngIf="rowAction.label">{{ rowAction.label | translate }}</span>
                                </button>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'toggle'">
                            <div 
                                [matTooltip]="toggleDisabledTooltip"
                                matTooltipPosition="above"
                                [matTooltipDisabled]="column.key !== 'we_access' || !isToggleDisabled(item, column.key) || !toggleDisabledTooltip"
                                class="toggle-wrapper">
                                <app-checkbox-toggle
                                [isChecked]="getPropertyValue(item, column.key) === true || getPropertyValue(item, column.key) === 'true'"
                                [disabled]="isToggleDisabled(item, column.key)"
                                (onChecked)="onToggleChanged(item, column.key, $event)">
                                </app-checkbox-toggle>
                            </div>
                        </ng-container>

                        <!-- Formato link: muestra enlace o texto 'No disponible' -->
                        <ng-container *ngSwitchCase="'link'">
                            <ng-container *ngIf="getPropertyValue(item, column.key); else noLink">
                                <a [href]="getPropertyValue(item, column.key)" target="_blank" class="text-primary underline cursor-pointer">
                                    {{ column.formatOptions?.linkText || ('commissions.view_invoice' | translate) }}
                                </a>
                            </ng-container>
                            <ng-template #noLink>
                                <span class="text-text-state-disabled">{{ column.formatOptions?.noLinkText || ('commissions.not_available_yet' | translate) }}</span>
                            </ng-template>
                        </ng-container>

                        <!-- Formato estándar -->
                        <ng-container *ngSwitchDefault>
                            {{ formatValue(getPropertyValue(item, column.key), column.format, column.formatOptions,item) }}
                        </ng-container>
                    </ng-container>
                    </div>

                    <span
                        *ngIf="shouldShowEmployeePhoneTooltip(colIndex, item)"
                        class="employee-phone-tooltip-trigger"
                        [matTooltip]="getEmployeePhone(item)"
                        matTooltipPosition="above"
                        [matTooltipShowDelay]="200"
                    >
                        i
                    </span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
